import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import lightLogo from "../../assets/images/delta-estate-b-w.png";
import darkLogo from "../../assets/images/delta-estate-b.png";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`navbar navbar-expand-lg ${
        scrolled ? "scrolled bg-white" : "bg-transparent-50"
      } fixed-top`}
    >
      <div className="container">
        <Link
          className={
            scrolled
              ? "navbar-brand text-dark fs-3"
              : "navbar-brand text-white fs-3"
          }
          to="/"
        >
          {scrolled ? (
            <img src={darkLogo} alt="Logo" />
          ) : (
            <img src={lightLogo} alt="Logo" />
          )}
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto sm-text-center">
            <li className="nav-item">
              <Link
                className={`nav-link ${scrolled ? "text-dark" : "text-white"}`}
                to="/"
              >
                Anasayfa
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${scrolled ? "text-dark" : "text-white"}`}
                to="/projects/residence"
              >
                Daire
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${scrolled ? "text-dark" : "text-white"}`}
                to="/projects/villa"
              >
                Villa
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${scrolled ? "text-dark" : "text-white"}`}
                to="/projects/store"
              >
                Mağaza
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${scrolled ? "text-dark" : "text-white"}`}
                to="/projects/all"
              >
                <i className="fas fa-helmet-safety me-2"></i>Tüm Projeler
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`btn ${
                  scrolled ? "btn-outline-dark" : "btn-outline-light"
                } ms-2`}
                to="tel:0555 555 55 55"
              >
                Bize Ulaşın
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
